import {promiseDebounce} from '../../library/utils/debounce';
import {getQuickSearchResults} from '../service';

enum quickSearchFieldType {
    userChoice = '89',
    default = '68'
}

const getFixQuery = query => {
    const escSpecialRegEx = new RegExp(/[?:"\-+&$]/g);

    const doubleSpace = new RegExp(/(\s\s)/);

    const endWithSpacialChar = new RegExp(/[-@&!*+?.,\\^$|#\\s]+$/g);

    //(?![@$%&!*+?.,]) - no spacial chars
    const spacesBetweenWrodsRegEx = new RegExp(/\s(?![@$%&!*+?.,])/g);

    //if has apostrophes
    if (query.match(/".*?"/)) {
        return `"${query.substring(1, query.length - 1).replace(escSpecialRegEx, '\\$&')}"`;
    }

    //if has no space at the end add asterisk
    const asterisk = query.match(/\s+$/) ? ' ' : '*';
    return `*${query
        .trim()
        .replace(spacesBetweenWrodsRegEx, ' AND ')
        .replace(endWithSpacialChar, ' $&')
        .replace(doubleSpace, ' ')
        .replace(escSpecialRegEx, '\\$&')}${asterisk}`;
};

async function getSearchResultAsync(query: string, formName: string) {
    if (query.length > 2) {
        const fixQuery = getFixQuery(query);
        const res = await getQuickSearchResults(fixQuery, formName);

        if (typeof res === 'string') {
            return [];
        }
        if (Object.keys(res).length > 0) {
            return res['response'];
        }
    }
    return [];
}
export const getSearchResult = promiseDebounce(getSearchResultAsync, 400);

//The parameter if the form is enable quick search
//It is enough for one column to have "qsrch:"1""
//to indicate that the form enabled quick search
export function getIsQuickSearch({hasqsrch, NewColumn}) {
    let isQuickSearch = false;
    if (hasqsrch === '1') {
        NewColumn.forEach(col => {
            if (col.qsrch === quickSearchFieldType.userChoice) {
                isQuickSearch = true;
            }
        });
    }
    return isQuickSearch;
}

export function getQuickSearchFields(data) {
    const fieldsArr = [];
    if (data && data.NewColumn) {
        data.NewColumn.forEach(col => {
            if (col.qsrch === quickSearchFieldType.userChoice) {
                fieldsArr.push(col.title);
            }
        });
    }
    return fieldsArr;
}
